/**
 * Created by Kim J on 2018-01-31.
 */
var DetailPaymentGOEAddFieldsController = (function () {
    function DetailPaymentGOEAddFieldsController(topic, $scope, socket) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.comp = 'goe_add_fields';
        this.visibleGOEAddFields = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp) > -1) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.goe_decl_letter_sent = ['Yes', 'No'];
    }
    DetailPaymentGOEAddFieldsController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailPaymentGOEAddFieldsController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                var updateObject = {
                    data: {
                        goe_add_fields: {
                            add: true,
                            data: this.topic.temp.goe_add_fields
                        }
                    },
                    id: this.topic.topic._id,
                    type: ['goe_add_fields']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailPaymentGOEAddFieldsController.prototype.toggleGOEAddFields = function () {
        this.visibleGOEAddFields = !this.visibleGOEAddFields;
    };
    DetailPaymentGOEAddFieldsController.$inject = ['topic', '$scope', 'socket', 'env'];
    return DetailPaymentGOEAddFieldsController;
}());
DetailPaymentGOEAddFieldsController = DetailPaymentGOEAddFieldsController;
var DetailPaymentGOEAddFieldsComponent = (function () {
    function DetailPaymentGOEAddFieldsComponent() {
        this.templateUrl = 'detail-payment-goe-addfields.html';
        this.controllerAs = 'vm';
        this.controller = DetailPaymentGOEAddFieldsController;
    }
    return DetailPaymentGOEAddFieldsComponent;
}());
angular
    .module('application')
    .component('detailPaymentGoeAddfields', new DetailPaymentGOEAddFieldsComponent());

//# sourceMappingURL=detail-payment-goe-addfields.component.js.map
